// @flow
import { ACTIONS } from '../constants';
import setNotificationsAsRead from '../api/setNotificationsAsRead';

const markNotificationsAsRead = () => (
    dispatch: Function,
    getState: Function
) => {
    const { notifications } = getState();
    const { notificationsList } = notifications;

    setNotificationsAsRead(notificationsList);

    dispatch({
        type: ACTIONS.NOTIFICATIONS_READ
    });
};

export default markNotificationsAsRead;
